import { render, staticRenderFns } from "./ProjectDetailCardstack.vue?vue&type=template&id=1d3c4b69"
import script from "./ProjectDetailCardstack.vue?vue&type=script&lang=js"
export * from "./ProjectDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports